import { ActivatedRoute } from '@angular/router';
import { Partners } from '@lockton-apps/shared/interfaces';
import { toInteger } from 'lodash';
import { inject } from '@angular/core';
import { LsosApplicationHooksService } from './services/lsos/lsos-application-hooks.service';
import { ProposalsHooksService } from './services/proposals-hooks.service';
import { NorwayApplicationHooksService } from './services/norway/norway-application-hooks.service';
import { ConstructionApplicationHooksService } from './services/construction/construction-application-hooks.service';
import { EnwApplicationHooksService } from './services/enw/enw-application-hooks.service';
import { RegulatoryApplicationHooksService } from './services/regulatory/regulatory-application-hooks.service';

export function routedPortalHooksFactory(
  activatedRoute: ActivatedRoute
): ProposalsHooksService<unknown> {
  const routedPortalId: Partners = toInteger(
    activatedRoute.snapshot.paramMap.get('portalId')
  );

  switch (routedPortalId) {
    case Partners.LSOS:
      return inject(LsosApplicationHooksService);

    case Partners.NORWAY:
    case Partners.NORWAY_PI:
      return inject(NorwayApplicationHooksService);

    case Partners.CONSTRUCTION:
      return inject(ConstructionApplicationHooksService);

    case Partners.ENW:
      return inject(EnwApplicationHooksService);

    case Partners.REGULATORY:
      return inject(RegulatoryApplicationHooksService);

    default:
      return new ProposalsHooksService();
  }
}
